<template>
  <button class="btn-share" @click.prevent.stop="share">共有</button>
</template>
<script setup lang="ts">
const props = defineProps({
  company: {
    type: Object,
    required: true
  }
});

const share = () => {
  navi.share(props.company);
};

</script>